import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PpButton } from './button.type';

@Component({
  selector: 'pp-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class PpButtonComponent implements OnInit {
  @Input() buttonConfig!: PpButton;

  @Input() disabled!: boolean;

  @Output() onClick = new EventEmitter<any>(true);

  constructor() {}

  ngOnInit() {}

  click() {
    this.onClick.emit(true);
  }
}
